import styled from "styled-components";

export const ToastWrapper = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.THEME.background};
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Sora", sans-serif;
  font-weight: 600;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  padding: 14px 28px;
  border-radius: 10px;
  box-shadow: 0 0 15px ${({ theme }) => theme.THEME.neonBlue};
  z-index: 9999;
  text-align: center;
  white-space: nowrap;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;
